"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onInstrumentSelect = void 0;
var _orderEntryActions = require("./orderEntryActions");
var _instrumentActions = require("./instrumentActions");
var onInstrumentSelect = exports.onInstrumentSelect = function onInstrumentSelect(instrumentId) {
  return function (dispatch) {
    dispatch((0, _instrumentActions.selectInstrument)(parseInt(instrumentId, 10)));
    dispatch((0, _orderEntryActions.clearBuySellForm)());
  };
};